async function fetchPage(url) {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const incoming = doc.querySelector('[data-portfolio-load-more]');
    const cards = [...(incoming?.querySelector('[data-portfolio-grid]')?.children ?? [])];
    if (!cards.length) throw new Error('No cards in response');

    return { cards, nextUrl: incoming.dataset.nextUrl || null };
}

export default () => ({
    nextUrl: null,
    loading: false,
    announcement: '',
    loadedUrls: [],

    init() {
        this.nextUrl = this.$el.dataset.nextUrl || null;

        const saved = history.state?.portfolioLoadedUrls;
        if (saved?.length) this.restore(saved, history.state.scrollY, history.state.portfolioFocusHref);
    },

    async restore(urls, scrollY, focusHref) {
        this.loading = true;

        try {
            const pages = await Promise.all(urls.map(fetchPage));
            for (const page of pages) this.append(page);
            this.loadedUrls = urls;
            scrollTo({ top: scrollY, behavior: 'instant' });
            this.grid().querySelector(`a[href="${CSS.escape(focusHref ?? '')}"]`)?.focus({ preventScroll: true });
        } catch {
            this.remember([]);
        } finally {
            this.loading = false;
        }
    },

    grid() {
        return this.$root.querySelector('[data-portfolio-grid]');
    },

    append({ cards, nextUrl }) {
        this.grid().append(...cards);
        this.nextUrl = nextUrl;
    },

    remember(urls) {
        this.loadedUrls = urls;
        history.replaceState({ ...history.state, portfolioLoadedUrls: urls }, '');
    },

    // Restoring the cards on back navigation drops focus to the top of the page,
    // so note which project was opened to hand focus back to it.
    rememberFocus(event) {
        const href = event.target.closest('a[href]')?.getAttribute('href');
        if (href) history.replaceState({ ...history.state, portfolioFocusHref: href }, '');
    },

    async loadMore(event) {
        if (!this.nextUrl) return;

        // Before the loading guard: a second click mid-request would otherwise
        // follow the href to the next page.
        event.preventDefault();
        if (this.loading) return;

        this.loading = true;

        const url = this.nextUrl;

        try {
            const page = await fetchPage(url);
            this.append(page);
            this.remember([...this.loadedUrls, url]);
            this.announcement = `${page.cards.length} more projects loaded, showing ${this.grid().children.length} of ${this.$root.dataset.totalItems}`;

            window.dataLayer?.push({ event: 'portfolio_load_more', page_url: url });

            this.$nextTick(() => page.cards[0].querySelector('a')?.focus({ preventScroll: true }));
        } catch {
            window.location.href = url;
        } finally {
            this.loading = false;
        }
    },
});
